"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsWrapper";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { useRef, useState } from "react";
type CollectionType = "memes" | "gradient" | "nextgen" | "memelab" | "rememes";
type CollectionsDropdownVariant = "default" | "title" | "brand";
interface CollectionItem {
  id: CollectionType;
  name: string;
  path: string;
}
const DEFAULT_COLLECTION: CollectionItem = {
  id: "memes",
  name: "The Memes",
  path: "/the-memes"
};
const COLLECTIONS: CollectionItem[] = [DEFAULT_COLLECTION, {
  id: "gradient",
  name: "Gradient",
  path: "/6529-gradient"
}, {
  id: "nextgen",
  name: "NextGen",
  path: "/nextgen"
}, {
  id: "memelab",
  name: "Meme Lab",
  path: "/meme-lab"
}, {
  id: "rememes",
  name: "ReMemes",
  path: "/rememes"
}];
interface Props {
  readonly activePage: CollectionType;
  readonly variant?: CollectionsDropdownVariant;
  readonly triggerContent?: ReactNode | undefined;
}
export default function CollectionsDropdown(props) {
  const $ = _c(42);
  const variant = props.variant ?? "default";
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  let t0;
  if ($[0] !== props.activePage) {
    t0 = COLLECTIONS.find(c => c.id === props.activePage) ?? DEFAULT_COLLECTION;
    $[0] = props.activePage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeCollection = t0;
  let t1;
  if ($[2] !== router) {
    t1 = collection => {
      setIsOpen(false);
      router.push(collection.path);
    };
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSelect = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      default: "tw-relative tw-block tw-w-full tw-truncate tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-py-3 tw-pl-3.5 tw-pr-10 tw-text-left tw-text-xs tw-font-semibold tw-text-iron-300 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-800 hover:tw-ring-iron-600 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 lg:tw-bg-iron-900",
      title: "tw-group tw-m-0 tw-inline-flex tw-min-w-0 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-md tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-text-xl tw-font-semibold tw-leading-tight tw-tracking-tight tw-text-iron-200 tw-transition tw-duration-200 hover:tw-text-white focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-400 sm:tw-text-2xl md:tw-text-3xl",
      brand: "tw-group tw-m-0 tw-inline-flex tw-min-w-0 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-md tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-transition tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-400"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const triggerClassNames = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      default: "tw-h-5 tw-w-5",
      title: "tw-h-5 tw-w-5 tw-shrink-0 tw-text-iron-400 tw-transition-colors tw-duration-200 group-hover:tw-text-white md:tw-h-6 md:tw-w-6",
      brand: "tw-h-5 tw-w-5 tw-shrink-0 tw-text-iron-400 tw-transition-colors tw-duration-200 group-hover:tw-text-white"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const iconClassNames = t3;
  const triggerContent = props.triggerContent ?? activeCollection.name;
  const isDefaultVariant = variant === "default";
  const t4 = `${iconClassNames[variant]} tw-transition-transform tw-duration-200 ${isOpen ? "tw-rotate-0" : "-tw-rotate-90"}`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <svg className={t4} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t5}</svg>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const chevron = t6;
  let t7;
  if ($[9] !== activeCollection || $[10] !== isDefaultVariant) {
    t7 = isDefaultVariant ? {} : {
      "aria-label": `Collection: ${activeCollection.name}`
    };
    $[9] = activeCollection;
    $[10] = isDefaultVariant;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isOpen) {
    t8 = () => setIsOpen(!isOpen);
    $[12] = isOpen;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = triggerClassNames[variant];
  let t10;
  if ($[14] !== chevron || $[15] !== isDefaultVariant || $[16] !== triggerContent || $[17] !== variant) {
    t10 = isDefaultVariant ? <>{triggerContent}<div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 -tw-mr-1 tw-flex tw-items-center tw-pr-3.5">{chevron}</div></> : <>{variant === "title" ? <span className="tw-min-w-0 tw-truncate">{triggerContent}</span> : triggerContent}{chevron}</>;
    $[14] = chevron;
    $[15] = isDefaultVariant;
    $[16] = triggerContent;
    $[17] = variant;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== isOpen || $[20] !== t10 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t11 = <button ref={buttonRef} type="button" aria-haspopup="true" aria-expanded={isOpen} {...t7} onClick={t8} className={t9}>{t10}</button>;
    $[19] = isOpen;
    $[20] = t10;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const triggerButton = t11;
  let t12;
  if ($[25] !== isDefaultVariant || $[26] !== triggerButton || $[27] !== variant) {
    t12 = () => {
      if (variant === "title") {
        return <span className="tw-min-w-0">{triggerButton}</span>;
      }
      if (isDefaultVariant) {
        return <div className="tw-relative tw-w-full">{triggerButton}</div>;
      }
      return triggerButton;
    };
    $[25] = isDefaultVariant;
    $[26] = triggerButton;
    $[27] = variant;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const renderTrigger = t12;
  const t13 = `tailwind-scope ${isDefaultVariant ? "tw-h-full tw-w-full" : "tw-min-w-0"}`;
  let t14;
  if ($[29] !== renderTrigger) {
    t14 = renderTrigger();
    $[29] = renderTrigger;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== handleSelect || $[32] !== isMobile || $[33] !== props.activePage) {
    t15 = COLLECTIONS.map(collection_0 => <li key={`collection-${collection_0.id}`} className="tw-h-full" role="none"><button type="button" role="menuitem" onClick={() => handleSelect(collection_0)} className={`${isMobile ? "tw-px-4 tw-py-3" : "tw-px-3 tw-py-2"} tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-2 tw-rounded-md tw-border-0 tw-bg-transparent tw-text-left tw-text-sm tw-font-medium tw-text-iron-200 tw-transition tw-duration-200 tw-ease-out hover:tw-bg-iron-800 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${collection_0.id === props.activePage ? "tw-bg-iron-800 tw-text-iron-100" : ""}`}><span className="tw-truncate">{collection_0.name}</span>{collection_0.id === props.activePage && <FontAwesomeIcon icon={faCheck} className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-primary-300" aria-hidden="true" />}</button></li>);
    $[31] = handleSelect;
    $[32] = isMobile;
    $[33] = props.activePage;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== isOpen || $[36] !== t15) {
    t16 = <CommonDropdownItemsWrapper isOpen={isOpen} filterLabel="Collection" buttonRef={buttonRef} setOpen={setIsOpen} onIsMobile={setIsMobile}>{t15}</CommonDropdownItemsWrapper>;
    $[35] = isOpen;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t13 || $[39] !== t14 || $[40] !== t16) {
    t17 = <div className={t13}>{t14}{t16}</div>;
    $[38] = t13;
    $[39] = t14;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
}